export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8577.0a3aca6c.jpg";